module.exports = __webpack_public_path__ + "static/media/pin_green.e2373103.svg";